import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShipmentTransportOrderOverview } from '../../models/shipment-transport-order.model';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import {
  ShipmentTransportOrderOverviewLoad,
  ShipmentTransportOrderOverviewSetInitialState,
} from './shipment-transport-order-main-info.actions';
import { ShipmentTransportOrderMainInfoService } from './shipment-transport-order-main-info.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentTransportOrderOverviewStateModel {
  overview: ShipmentTransportOrderOverview;
  loaded: boolean;
}

const initialState: ShipmentTransportOrderOverviewStateModel = {
  overview: null,
  loaded: false,
};

@State<ShipmentTransportOrderOverviewStateModel>({
  name: 'shipmentTransportOrderOverview',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderMainInfoState {
  constructor(
    private shipmentTransportOrderOverviewService: ShipmentTransportOrderMainInfoService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getLoaded(state: ShipmentTransportOrderOverviewStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getOverview(state: ShipmentTransportOrderOverviewStateModel): ShipmentTransportOrderOverview {
    return state.overview;
  }

  @Action(ShipmentTransportOrderOverviewLoad)
  getWaybillOverview(
    ctx: StateContext<ShipmentTransportOrderOverviewStateModel>,
    { payload }: ShipmentTransportOrderOverviewLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentTransportOrderOverviewService.getOverviewData(payload).pipe(
      map((overview: ShipmentTransportOrderOverview) => {
        ctx.patchState({ overview, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderOverviewSetInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderOverviewStateModel>): void {
    ctx.setState(initialState);
  }
}
